/** POST de acceso al último módulo: registra qué módulo abrió el usuario para ofrecer el ingreso directo. */
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiCall } from "../apiHelper";
import { LoggedUserInnerwork } from "@/types";

export const POSTAccesoUltimoModulo = (loggedUserInnerwork: LoggedUserInnerwork, idModulo: number) =>
  apiCall({
    method: "post",
    url: `${API_ENDPOINTS.POST_ULTIMOMODULO}?codUsuario=${loggedUserInnerwork.codUsuario}&idModulo=${idModulo}`,
    data: {},
  });
